<template>
  <div class="container no-margin">
    <!-- <div class="date-options-container">
      <img class="icon" v-if="showIcon" :src="icon" alt="Ícono desplegar" />
    </div> -->
    <text-input
      v-mask="'##/##/####'"
      hint="DD/MM/YYYY"
      label="Fecha de nacimiento"
      :name="name"
      pattern="[0-9]*"
      inputmode="numeric"
      @input="onInput"
      @click="$emit('click')"
      @onFocus="$emit('onFocus')"
      :value="value"
      :required="required"
      :subhint="subhint"
      :validationError="validationError"
      :analyticsName="analyticsName"
      :analyticsTypology="config.analyticsTypology"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import TextInput from "@/__tests-ab__/AR2024CNOMV2/components/core/TextInput";
import { isValidDate } from "@/utils";

export default {
  name: "DateField",
  components: { TextInput },
  directives: {
    mask
  },
  props: {
    value: String,
    name: String,
    required: Boolean,
    subhint: String,
    minAge: Number,
    maxAge: Number,
    compatible: {
      type: Boolean,
      default: true
    },
    debeSerMayor: {
      type: Boolean,
      default: false
    },
    analyticsName: {
      type: String,
      default: null
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validationError: null,
      // icon: require("@/assets/img/1x/calendar-grey.svg"),
      checked: false
    };
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
      if (this.checked) {
        this.isValid(val);
      }
    },
    // showIcon() {
    //   return !this.value;
    // },
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isValid(val) {
      // Por problema de sincronía con v-bind, paso el valor
      // por parámetro en onInput
      let value = val ? val : this.value;
      if (this.debeSerMayor) {
        let fecha = new Date(value);
        let fechaReferencia = new Date();
        fechaReferencia.setFullYear(fechaReferencia.getFullYear() - 18);
        if (fecha > fechaReferencia) {
          this.validationError = "Debe ser mayor de 18 años";
          return false;
        }
      }

      if (!this.compatible) {
        this.validationError =
          "Número de documento incompatible con fecha de nacimiento";
        return false;
      }

      /* Sobreescribir método de validación */
      if (value && !isValidDate(value, this.minAge, this.maxAge)) {
        // La fecha no es válida
        this.validationError = "La fecha no es válida";
        return false;
      }

      // La fecha es válida
      this.validationError = null;
      return true;
    }
  }
};
</script>

<style scoped>
/* .date-options-container {
  position: relative;
} */

/* .date-options-container .icon {
  position: absolute;
  top: 18px;
  right: 20px;
  z-index: 1;
  width: 22px;
  background: white;
} */
</style>
